import React from "react";
import { Pie, PieConfig } from "@ant-design/plots";
import { CHART_PALETTE } from "../../chartPalette";

const PieChart = () => {
  const data = [
    { type: "Cat 1", value: 27 },
    { type: "Cat 2", value: 25 },
    { type: "Cat 3", value: 18 },
    { type: "Cat 4", value: 15 },
    { type: "Cat 5", value: 10 },
    { type: "Cat 6", value: 40 },
    { type: "Cat 7", value: 50 },
    { type: "Other", value: 5 },
  ];

  const config: PieConfig = {
    data,
    // One height for all four, so the cards line up in the grid.
    height: 320,
    angleField: "value",
    colorField: "type",
    radius: 0.8,
    label: {
      text: (d: any) => `${d.type}\n ${d.value}`,
      position: "spider",
    },
    legend: {
      color: {
        title: false,
        // Chart on the left, legend down the right side.
        position: "right",
        rowPadding: 5,
      },
    },
    theme: {
      category10: CHART_PALETTE,
    },
  };

  return <Pie {...config} />;
};

export default PieChart;
